'use strict';
import fastdom from 'fastdom';
import fastdomPromised from 'fastdom/extensions/fastdom-promised';

var fd = fastdom.extend(fastdomPromised);

export default fd;

export {fd};

export function measure(callback) {
    return function (value) {
        return fd.measure(function () {
            return callback(value);
        });
    };
}

export function mutate(callback) {
    return function (value) {
        return fd.mutate(function () {
            return callback(value);
        });
    };
}
